export default __webpack_public_path__ + "static/media/90.00d354ba.jpg";